/// <amd-module name="Environments/Providers/VirtualMachineGroups/Common/Utils" />
import { VirtualMachine } from "DistributedTask/Client/Contracts/TaskAgent";
export class Operation {
    public static GetPATToken: string = "pattoken";
    public static GetTaskAgentPool: string = "taskAgentPool";
    public static GetTargetPackages: string = "targetPackages";
}

export interface IVirtualMachineTagsInfo {
    machine: VirtualMachine;
    tags: string[];
}